import React, { ReactNode } from 'react';
import { InfoIcon } from '@vwfs-bronson/bronson-react';

interface ITooltipInfoIconProps {
    children: ReactNode | ReactNode[];
    testId?: string;
}

const TooltipInfoIcon = ({ children, testId }: ITooltipInfoIconProps) => {
    return <InfoIcon
        testId={testId}
        className="semantic-info"
        tippyProps={{
            appendToBody: true,
        }}>{children}</InfoIcon>
}

export default TooltipInfoIcon;